import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getAlarmDetails = async (authHelper: AuthHelper, args: { alarmId: string; deviceId: string }) => {
    const result = await ApiRequests.getAlarmDetails(
        {
            alarmId: args.alarmId,
            deviceId: args.deviceId,
        },
        { authHelper }
    );

    if (!result.ok) {
        console.error(ApiRequests.extractErrorCodeWithMessage(result.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(result.response));
    }

    return {
        alarmId: result.response.data.alarmDetails.alarmId,
        trigger: result.response.data.alarmDetails.trigger,
        severity: result.response.data.alarmDetails.severity,
        channelName: result.response.data.alarmDetails.channelName,
        channelId: result.response.data.alarmDetails.channelId,
        unit: result.response.data.alarmDetails.unit,
        incidentId: result.response.data.alarmDetails.incidentId,
        deviceId: result.response.data.alarmDetails.deviceId,
        deviceName: result.response.data.alarmDetails.deviceName,
        deviceVendor: result.response.data.alarmDetails.deviceVendor || '',
        latestTime: result.response.data.alarmDetails.latestTime,
        latestValue: result.response.data.alarmDetails.latestValue,
        occuredTime: result.response.data.alarmDetails.occuredTime,
        occuredValue: result.response.data.alarmDetails.occuredValue,
        priority: result.response.data.alarmDetails.priority,
        status: result.response.data.alarmDetails.status,
        threshold: result.response.data.alarmDetails.threshold,
        acknowledgeUser: result.response.data.alarmDetails.acknowledgeUser,
        acknowledgeTime: result.response.data.alarmDetails.acknowledgeTime,
        acknowledgeValue: result.response.data.alarmDetails.acknowledgeValue,
        note: result.response.data.alarmDetails.note,
    };
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getAlarmChannelDetailResponse = async (authHelper: AuthHelper, deviceId: string, alarmId: string) => {
    const responseAlarmDetail = await ApiRequests.alarmChannelDetail(
        {
            deviceId: deviceId,
            alarmId: alarmId
        },
        {
            authHelper
        }
    );  
    if (!responseAlarmDetail.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(responseAlarmDetail.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(responseAlarmDetail.response));
    }

   
    return responseAlarmDetail.response.data;
};

export { getAlarmDetails,getAlarmChannelDetailResponse };
